"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _Building = _interopRequireDefault(require("@decisiv/iconix/lib/components/Building"));

var _Badge = _interopRequireDefault(require("../../Badge"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Typography = require("../../Typography");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGO_HEIGHT_PX = 36;

var LogoImage = _styledComponents.default.img.withConfig({
  displayName: "BrandInfo__LogoImage",
  componentId: "zv4bhm-0"
})(["background-color:", ";border-radius:", ";height:", ";width:", ";object-fit:contain;"], (0, _toColorString.default)(_color.default.base.snowWhite), (0, _rem.default)(LOGO_HEIGHT_PX / 2), (0, _rem.default)(LOGO_HEIGHT_PX), (0, _rem.default)(LOGO_HEIGHT_PX));

function BrandInfo(_ref) {
  var logo = _ref.logo,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText;
  return _react.default.createElement(_Flex.default, {
    alignItems: "center"
  }, !logo ? _react.default.createElement(_Badge.default, {
    "aria-label": "",
    icon: _Building.default
  }) : _react.default.createElement(LogoImage, {
    alt: "",
    src: logo
  }), _react.default.createElement(_Flex.default, {
    flexDirection: "column",
    marginLeft: 1
  }, _react.default.createElement(_Typography.H4, {
    shade: 2,
    truncate: true,
    weight: "semibold"
  }, primaryText), secondaryText && _react.default.createElement(_Typography.P, {
    as: "span",
    color: "halfMoon",
    truncate: true
  }, secondaryText)));
}

BrandInfo.propTypes = _schema.default.propTypes;
BrandInfo.defaultProps = _schema.default.defaultProps;
var _default = BrandInfo;
exports.default = _default;